import { render, staticRenderFns } from "./BillingOverview.vue?vue&type=template&id=8d8d8952&"
import script from "./BillingOverview.vue?vue&type=script&lang=js&"
export * from "./BillingOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports